/**
 * The API paths and request headers (spec 9.6), kept apart from the Zod schemas of
 * ./wire so the main thread can address the API without pulling the validators into the
 * shell chunk. ./wire re-exports them; import from `@satu/shared` as before.
 */

export const API_PATHS = {
  push: '/sync/push',
  pull: '/sync/pull',
  snapshotBegin: '/sync/snapshot/begin',
  snapshot: '/sync/snapshot',
  health: '/health',
  /** Section 05: the device registers itself after login (spec 15, 17.5). */
  enrol: '/devices/enrol',
  /** Section 05: who the token belongs to, with the names the header and the PIN screen show. */
  sesi: '/sesi',
  /** Duplicates (owner, 2026-10-04): an online device asks before a save (./ganda). */
  ganda: '/sync/ganda',
  /** Peta umat (release 20): where an address lies (../peta/alamat). */
  cariLokasi: '/peta/cari-lokasi',
  /** Peta umat: the point a short map link leads to (../peta/tautan). */
  bukaTautan: '/peta/buka-tautan',
} as const

/** Every request but /health carries the app version here (spec 9.6). */
export const CLIENT_VERSION_HEADER = 'X-SATU-Client'
/** The enrolled device id; the gate cross-checks `perangkat` when present (spec 15.2). */
export const DEVICE_HEADER = 'X-SATU-Device'
/**
 * Legacy wire names from SIMU (release 24: SIMU is now SATU); kept so apps on release 23 or
 * older keep syncing. The server reads either spelling, the new one first, with no end date. The
 * app sends both, so a rollback to release 23 still understands an updated device.
 */
export const CLIENT_VERSION_HEADER_LAMA = 'X-SIMU-Client'
/** Legacy wire name from SIMU; kept so apps on release 23 or older keep syncing. */
export const DEVICE_HEADER_LAMA = 'X-SIMU-Device'
